var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M12.8725 0.666992C19.546 0.666992 24.956 6.03957 24.956 12.667C24.956 19.2944 19.546 24.667 12.8725 24.667C6.19901 24.667 0.789062 19.2944 0.789062 12.667C0.789062 6.03957 6.19901 0.666992 12.8725 0.666992ZM12.8725 5.46699C12.2052 5.46699 11.6642 6.00426 11.6642 6.66699V12.667C11.6642 12.9852 11.7915 13.2905 12.0181 13.5155L15.6431 17.1155C16.115 17.5841 16.8801 17.5841 17.352 17.1155C17.8239 16.6469 17.8239 15.8871 17.352 15.4185L14.0809 12.17V6.66699C14.0809 6.00426 13.5399 5.46699 12.8725 5.46699Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a4c43bcfa2db0da8fbeaddf83494654a.svg";
export { ForwardRef as ReactComponent };